import React, { useState } from "react";
import { FileText, Download, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useReportsController } from "./useReportsController";
import { ReportingPeriodTimeline } from "@/features/reporting-periods";
import { MockedDataBar } from "@/components/MockedDataBar";
import { useAtomValue } from "jotai";
import { SelectedFundAtom } from "@/store/FundStateAtom";
import { ReportGenerator } from "./components/ReportGenerator";
import { ReportHistory } from "./components/ReportHistory";

export const ReportsView: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("generate");
  const selectedFund = useAtomValue(SelectedFundAtom);
  const {
    isGeneratingReport,
    isLoadingData,
    selectedReportingPeriod,
    generateReport,
    reportHistory,
    downloadReport,
    getReportPreviewData,
    holdings,
    transactions,
  } = useReportsController();

  if (!selectedFund) {
    return (
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <FileText className="h-6 w-6 mr-2 text-primary" />
            <h1 className="text-3xl font-bold">Reports</h1>
          </div>
        </div>

        <Alert variant="default" className="mb-6">
          <Info className="h-4 w-4" />
          <AlertTitle>No fund selected</AlertTitle>
          <AlertDescription>
            Please select a fund to view and generate reports.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container max-w-8xl">
      

      <ReportingPeriodTimeline />

     
         
              <ReportGenerator
                selectedReportingPeriod={selectedReportingPeriod}
                isGeneratingReport={isGeneratingReport}
                isLoadingData={isLoadingData}
                holdings={holdings}
                transactions={transactions}
                getReportPreviewData={getReportPreviewData}
                onGenerateReport={generateReport}
              />
    </div>
  );
};
